module.exports = __webpack_public_path__ + "static/LGCassetteImage-e8981e2f7996aaaa8ea202b16f8076db.jpeg";